import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { branchesPost } from "../../store/branches/actions";
export var useBranchesPost = function (trigger, body) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responseBranchesPost: (_a = state.Branches.responseBranchesPost) === null || _a === void 0 ? void 0 : _a.data,
            errorBranchesPost: state.Branches.errorBranchesPost,
            loadingBranchesPost: state.Branches.loadingBranchesPost,
        });
    }), responseBranchesPost = _a.responseBranchesPost, errorBranchesPost = _a.errorBranchesPost, loadingBranchesPost = _a.loadingBranchesPost;
    useEffect(function () {
        if (trigger) {
            dispatch(branchesPost({
                name: body.data.name,
                code: body.data.code,
                status: body.data.status,
                clientId: body.data.clientId,
            }));
        }
    }, [trigger, body.data.clientId]);
    return {
        responseBranchesPost: responseBranchesPost,
        errorBranchesPost: errorBranchesPost,
        loadingBranchesPost: loadingBranchesPost,
    };
};
